export default "__VITE_ASSET__C8QeR$32__"